export default {
      id: "logo-white-usage",
      viewBox: "0 0 277 96",
      url: __webpack_public_path__ + "svg/sprite.svg#logo-white",
      toString: function () {
        return this.url;
      }
    }